import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from '@openng/optimus-ui/table';
import { GeneStatsRoutingModule } from './gene-stats-routing.module';
import { GeneStatsComponent } from './gene-stats.component';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '@shared';

@NgModule({
  imports: [CommonModule, GeneStatsRoutingModule, TableModule, BrowserModule, SharedModule],
  declarations: [GeneStatsComponent],
})
export class GeneStatsModule {}
